var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNavbarNotification(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.277832,
    width: 32,
    height: 32,
    rx: 14,
    fill: "#A2AACA",
    fillOpacity: 0.6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.001 23.2778C16.8711 23.2778 17.583 22.5855 17.583 21.7394H14.419C14.419 22.1474 14.5856 22.5387 14.8823 22.8272C15.179 23.1157 15.5814 23.2778 16.001 23.2778ZM20.747 18.6624V14.8163C20.747 12.4548 19.4498 10.4778 17.1875 9.95475V9.43168C17.1875 8.79322 16.6575 8.27783 16.001 8.27783C15.3444 8.27783 14.8145 8.79322 14.8145 9.43168V9.95475C12.5443 10.4778 11.2549 12.4471 11.2549 14.8163V18.6624L10.2345 19.6548C9.73618 20.1394 10.0842 20.9701 10.7882 20.9701H21.2058C21.9098 20.9701 22.2658 20.1394 21.7674 19.6548L20.747 18.6624Z",
    fill: "#A2AACA"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavbarNotification);
export default __webpack_public_path__ + "static/media/navbar_notification.f43ff0ff.svg";
export { ForwardRef as ReactComponent };